import ercAbi from "../blockchains/abi/erc.json";
import collectionAbi from "../blockchains/abi/collection.json";
import { ethers } from "ethers";

function initialWeb3() {
  return new ethers.providers.Web3Provider(window.ethereum, "any");
}

function initialWeb3WithProvider(rpc) {
  return new ethers.providers.JsonRpcProvider(rpc);
}

function checkIsAddress(contractAddress) {
  return ethers.utils.isAddress(contractAddress);
}

async function getTokenInfo(contractAddress, rpc) {
  const provider = initialWeb3WithProvider(rpc);
  const contract = new ethers.Contract(contractAddress, ercAbi, provider);
  return Promise.all([
    contract.decimals(),
    contract.symbol(),
    contract.name(),
  ]).then((res) => res);
}

async function getCollectionInfo(contractAddress, rpc) {
  const provider = initialWeb3WithProvider(rpc);
  const contract = new ethers.Contract(
    contractAddress,
    collectionAbi,
    provider
  );
  return Promise.all([contract.symbol(), contract.name()]).then((res) => res);
}

export { getTokenInfo, getCollectionInfo, checkIsAddress, initialWeb3 };
